import ImmediateUploadButtonContainer from './immediate_upload_button_container';

const ImmediateUploadButton = ImmediateUploadButtonContainer;
export default ImmediateUploadButton;
